import { SVGProps } from '../types';

const McpIcon = (props: SVGProps) => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M8.90616 0.343999H9.34416L9.96883 0.468666L10.5002 0.718666L10.8128 0.937333L11.2815 1.43733L11.6562 2.156L11.7815 2.75L11.7502 3.344L12.8128 3.43733L13.1875 3.56267L13.8128 3.93733L14.2502 4.37467L14.6255 5L14.7815 5.5L14.8442 6.06267L14.8128 6.43733L14.6562 7.03133L14.2815 7.68733L8.53149 13.4687L8.56283 13.6253L9.78149 14.844L9.84416 14.9687L9.87483 15.2187L9.78149 15.4373L9.62549 15.594L9.46883 15.656H9.21883L9.06283 15.594L7.75016 14.2813L7.62549 14.094L7.50016 13.6873L7.56283 13.094L7.75016 12.75L13.4375 7.06267L13.6562 6.71867L13.7815 6.31267L13.7502 5.656L13.5315 5.156L13.1875 4.78133L12.7188 4.5L12.3748 4.406H11.9375L11.5628 4.5L11.0628 4.81267L6.37483 9.5L6.15616 9.594H6.00016L5.78149 9.5L5.59416 9.28133L5.56283 8.93733L5.65616 8.75L10.3748 4.03133L10.5315 3.81267L10.7188 3.31267V2.68733L10.5315 2.18733L10.1562 1.75L9.75016 1.5L9.18749 1.37467L8.68749 1.43733L8.21883 1.656L1.87483 7.96867L1.75016 8.03133H1.40616L1.15616 7.844L1.06283 7.62533V7.43733L1.15616 7.21867L7.43749 0.937333L8.12549 0.531333L8.90616 0.343999Z"
      fill="currentColor"
    />
    <path
      d="M9.09392 2.46867L9.37458 2.53133L9.59392 2.75L9.65592 3.06267L9.53125 3.344L4.87458 8L4.74992 8.18733L4.56258 8.75V9.18733L4.65592 9.56267L4.87458 9.93733L5.21858 10.2813L5.71858 10.5313L6.31258 10.594L6.87458 10.4373L7.12525 10.2813L11.8746 5.56267L12.2499 5.5L12.4686 5.594L12.6559 5.87467L12.6252 6.25L7.90592 11L7.65592 11.1873L7.18725 11.4373L6.43725 11.6253L5.68725 11.594L5.15592 11.4373L4.68725 11.1873L4.15592 10.7187L3.90592 10.3747L3.68725 9.93733L3.53125 9.344V8.594L3.71858 7.93733L3.96858 7.46867L4.24992 7.12533L8.78125 2.594L9.09392 2.46867Z"
      fill="currentColor"
    />
  </svg>
);

export { McpIcon };
